import PropTypes from 'prop-types';

import './index.less';

function Subheader({ children }) {
  return <div className='layout__subheader'>{children}</div>;
}

Subheader.propTypes = {
  children: PropTypes.node,
};

export default Subheader;
